export default __webpack_public_path__ + "static/media/javascript-game-demo-v2.342432c4.mp4";